import type { ReactNode } from 'react';
import { useUiStore } from '@/app/ui-store';
import { SearchBox } from '@/features/search/search-box';
import logo from '@/assets/logo.png';
import { APP_NAME } from '@shared/config';
import { MenuOutlined, MoonOutlined, SunOutlined } from '@ant-design/icons';

export function GlobalNav({ right }: { right?: ReactNode }) {
  const theme = useUiStore((s) => s.theme);
  const toggleTheme = useUiStore((s) => s.toggleTheme);
  const toggleSidebar = useUiStore((s) => s.toggleSidebar);
  const setMobileSidebar = useUiStore((s) => s.setMobileSidebar);
  const mobileOpen = useUiStore((s) => s.mobileSidebarOpen);

  const onToggle = () => {
    if (window.matchMedia('(max-width: 768px)').matches) setMobileSidebar(!mobileOpen);
    else toggleSidebar();
  };

  return (
    <nav id="global-nav">
      <button type="button" className="nav-toggle" aria-label="Toggle sidebar" onClick={onToggle}><MenuOutlined /></button>
      <div className="nav-logo" aria-label="Vets Relief Solutions LLC">
        <img className="brand-logo-img" src={logo} alt="Vets Relief Solutions LLC logo" />
        <span id="logo-text" className="brand-wordmark"><strong>{APP_NAME}</strong><small>Veteran-Led. Technology-Driven.</small></span>
      </div>
      <SearchBox />
      <div className="nav-spacer" />
      <button type="button" className="nav-icon-btn" title="Toggle light/dark mode" aria-label="Toggle theme" onClick={toggleTheme}>
        {theme === 'light' ? <MoonOutlined /> : <SunOutlined />}
      </button>
      {right}
    </nav>
  );
}
